// Shared ringtone utility — Web Audio API, no file needed
// G5 G5 D5 E5 pattern — pleasant, distinct from system sounds
export function playRingtone() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const notes = [
      { freq: 784, start: 0.00, dur: 0.12 },  // G5
      { freq: 784, start: 0.16, dur: 0.12 },  // G5
      { freq: 587, start: 0.32, dur: 0.12 },  // D5
      { freq: 659, start: 0.48, dur: 0.22 },  // E5 (held)
    ];
    notes.forEach(({ freq, start, dur }) => {
      const osc  = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      const t = ctx.currentTime + start;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.35, t + 0.02);
      gain.gain.setValueAtTime(0.35, t + dur - 0.03);
      gain.gain.linearRampToValueAtTime(0, t + dur);
      osc.start(t);
      osc.stop(t + dur + 0.05);
    });
  } catch (e) {
    console.warn('[sound] ringtone failed:', e.message);
  }
}
